import script from "./cqBtn.vue?vue&type=script&setup=true&lang=js"
export * from "./cqBtn.vue?vue&type=script&setup=true&lang=js"

import "./cqBtn.vue?vue&type=style&index=0&id=3af80844&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src2302593107/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3af80844"]])

export default __exports__